import { FC, Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
// Types
import IPage from 'models/Page';
// Components
import Accordion from 'components/Accordion';
import BannerForm from './BannerForm';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  bannerRef: string;
  defaultExpanded?: boolean;
}

const Banner: FC<Props> = ({ bannerRef, defaultExpanded }) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const watchedPages = watch('pages');
  const pageRef = watchedPages.find((page: IPage) => page.refs.includes(bannerRef))?.uuid;

  return (
    <Fragment>
      <Accordion
        label={`${t('labels.interstitial')} ${t('labels.page')}`} icon="images"
        previewPage="media" previewPageRef={pageRef}
        defaultExpanded={defaultExpanded}
      >
        <BannerForm bannerRef={bannerRef} />
      </Accordion>
    </Fragment>
  );
};

export default Banner;
